<script>
  import { getContext } from 'svelte';
  import SectionNav from '../../../../components/navigation/section';
  import {
    addNotification,
    ICONS,
  } from '../../../../utils/notifications.store';

  import ProgramGeneral from './program.general';
  import ProgramPartner from './program.partner';
  import ProgramDetails from './program.details';
  import ProgramCommunications from './program.communications';

  import {
    ADD_PROGRAM,
    programValueToInput,
  } from '../../../../graphql/programs';

  const history = getContext('history');
  const client = getContext('apollo');

  export let value;

  async function save() {
    const input = programValueToInput(value);

    if (value.id) {
      input.id = value.id;
    }

    const variables = {
      input,
    };

    try {
      addNotification({ icon: ICONS.LOADING, message: `Saving ${value.name}` });

      const response = await client.mutate({
        mutation: ADD_PROGRAM,
        variables: {
          input: Object.assign(input, {
            constraints: Object.assign(input.constraints, {
              capacity: input.constraints.capacity
                ? parseInt(input.constraints.capacity)
                : 0,
              staff: input.constraints.staff
                ? parseInt(input.constraints.staff)
                : 0,
            }),
          }),
        },
      });

      addNotification({
        time: 2000,
        message: `Successfully Saved ${value.name}`,
        icon: ICONS.SUCCESS,
      });

      history.push(`/programs/view/${response.data.addProgram.id}`);
    } catch (e) {
      addNotification({
        message: `Error Saving ${value.name}`,
        icon: ICONS.ERROR,
        time: 2000,
      });
    }
  }
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <ProgramGeneral review="{true}" value="{value}"></ProgramGeneral>
    <ProgramPartner review="{true}" value="{value}"></ProgramPartner>
    <ProgramDetails review="{true}" value="{value}"></ProgramDetails>
    <ProgramCommunications
      review="{true}"
      value="{value}"
    ></ProgramCommunications>
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav hasSub="{true}">
      <div on:click="{save}" class="save">
        ADD PROGRAM
      </div>
    </SectionNav>
  </div>
</div>
